import { render, staticRenderFns } from "./RiskAnalysisLevel.vue?vue&type=template&id=1f3147a0&"
import script from "./RiskAnalysisLevel.vue?vue&type=script&lang=js&"
export * from "./RiskAnalysisLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports